import { DeclineCandidateConfirmationPopup } from '~/components/PermanentJobsV2/JobOverview/components/DeclineCandidatePopups/DeclineCandidateConfirmationPopup';
import { DeclineCandidateSuccessPopup } from '~/components/PermanentJobsV2/JobOverview/components/DeclineCandidatePopups/DeclineCandidateSuccessPopup';
import type { ICandidateOnsiteInterviewEntity } from '~/domain/PermanentJobs';
import type { TOnsiteInterviewActions } from '../../hooks/useOnsiteInterviewActions';
import { InterviewDetailsModal } from '../InterviewDetailsModal';

interface IOnsiteInterviewActionModalsProps {
  actions: TOnsiteInterviewActions;
  maps: Record<string, ICandidateOnsiteInterviewEntity>;
  professionalId: string;
  professionalName: string;
}

/** The confirm and decline dialogs `useOnsiteInterviewActions` opens. */
export const OnsiteInterviewActionModals = ({
  actions: { confirm, decline, handleCloseDeclineSuccessPopup },
  maps,
  professionalId,
  professionalName,
}: IOnsiteInterviewActionModalsProps) => (
  <>
    {confirm.isOpen &&
      confirm.selectedInterviewId &&
      maps[confirm.selectedInterviewId]?.counterOffer && (
        <InterviewDetailsModal
          counterOffer={maps[confirm.selectedInterviewId].counterOffer!}
          interviewId={confirm.selectedInterviewId}
          isLoading={confirm.isConfirming}
          professionalId={professionalId}
          onClose={confirm.handleCloseConfirmInterview}
          onConfirm={confirm.handleConfirmCandidateInterview}
        />
      )}

    {decline.isOpen && !decline.isDeclineSuccess && (
      <DeclineCandidateConfirmationPopup
        isLoading={decline.isDeclining}
        jobLocalDate={maps[decline.selectedInterviewId || '']?.localDate}
        professionalName={professionalName}
        onClose={decline.handleCloseDeclineInterview}
        onConfirm={decline.handleConfirmDeclineInterview}
      />
    )}

    {decline.isDeclineSuccess && (
      <DeclineCandidateSuccessPopup
        professionalName={professionalName}
        onClose={handleCloseDeclineSuccessPopup}
      />
    )}
  </>
);
